module.exports = __webpack_public_path__ + "static/portfolio-1-0d94726b3d4dc5a1da3acd0004d31724.jpg";